import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import CasesDetailContainer from 'src/ui/features/Cases/containers/CasesDetailContainer';
import { updateBodyClass } from 'src/helpers';
import { CASES_URL, BODY_CLASSES } from 'src/constants/constants.js';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

class CasesRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.CASES);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.CASES);
  }

  render() {
    return (
      <Layout headerName={intl.get('globalMenu.cases')}>
        <Switch>
          <Route path={CASES_URL + '/detail/:caseId'} render={props => <CasesDetailContainer {...props} />} />
        </Switch>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(CasesRoot);
